import React from 'react';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 1) {
    return 'Today';
  } else if (diffDays === 2) {
    return 'Yesterday';
  } else if (diffDays <= 7) {
    return `${diffDays - 1} days ago`;
  } else {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
};

export default function ThreadSidebar({ threads, currentSession, onSelectSession, onCreateNew, onDeleteSession }) {
  const handleDelete = (e, sessionId) => {
    e.stopPropagation(); // Prevent triggering thread selection
    if (window.confirm('Are you sure you want to delete this conversation?')) {
      onDeleteSession(sessionId);
    }
  };

  return (
    <div className="thread-sidebar">
      <div className="sidebar-header">
        <h2>Maestro</h2>
        <button onClick={onCreateNew} className="new-chat-button" title="New Chat">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          New Chat
        </button>
      </div>
      <div className="thread-list">
        {threads.length === 0 ? (
          <div style={{ padding: '16px', textAlign: 'center', color: 'var(--text-tertiary)', fontSize: '13px' }}>
            No conversations yet
          </div>
        ) : (
          threads.map((thread) => (
            <div
              key={thread.id}
              className={`thread-item ${thread.id === currentSession ? 'active' : ''}`}
              onClick={() => onSelectSession(thread.id)}
              title={thread.title || 'New Chat'}
            >
              <div className="thread-content">
                <div className="thread-title">{thread.title || 'New Chat'}</div>
                <div className="thread-date">
                  {formatDate(thread.updatedAt)}
                </div>
              </div>
              <button
                className="thread-delete-button"
                onClick={(e) => handleDelete(e, thread.id)}
                title="Delete conversation"
                aria-label="Delete conversation"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

